import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

/**
 * Firebase configuration for FylePrep application
 * Connected to fyleprep-app Firebase project
 */
const firebaseConfig = {
  apiKey: "AIzaSyBiBCXB3tBSBNBIedv2FkYkUrPM6Hh_uzA",
  authDomain: "fyleprep-app.firebaseapp.com",
  projectId: "fyleprep-app",
  storageBucket: "fyleprep-app.firebasestorage.app",
  messagingSenderId: "28407831273",
  appId: "1:28407831273:web:18ec1b7a3ac064755f2e78"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
